import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "@toddle-edu/ds-web";
import Loading from "UIComponents/Loading";
import { WarningCircleOutlined, TickCircleFilled } from "@toddle-edu/ds-icons";
import classNames from "classnames";
import classes from "./UpdateEquationsModal.scss";

import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";

const UpdateEquationsModal = ({ testId, isAborted, isSuccess, t, onClose }) => {
  const titleClass = classNames(classes.title);
  const descriptionClass = classNames("text-body-l", classes.description);

  const getTitle = () => {
    if (isSuccess) return t("equationEditor:update_successful");
    if (isAborted) return t("equationEditor:update_unsuccessful");
    return t("equationEditor:updating_equations");
  };

  const getDescription = () => {
    if (isSuccess) return t("equationEditor:equations_updated_successfully");
    if (isAborted) return t("equationEditor:update_interrupted_tab_switch");
    return t("equationEditor:do_not_switch_tabs_during_operation");
  };

  const renderIcon = () => {
    if (isSuccess) {
      return (
        <TickCircleFilled className={classes.successIcon} variant="success" />
      );
    }
    if (isAborted) {
      return (
        <WarningCircleOutlined
          className={classes.warningIcon}
          variant="critical"
        />
      );
    }
    return <Loading />;
  };

  return (
    <Modal
      dsVersion="2.0"
      width="480px"
      height="fit-content"
      isClosable={false}
    >
      <Modal.Body>
        <div className={classes.modalBodyContent}>
          {renderIcon()}
          <div className={classes.contentContainer}>
            <h5 className={titleClass}>{getTitle()}</h5>
            <div className={descriptionClass}>{getDescription()}</div>
          </div>
          {(isAborted || isSuccess) && (
            <Button
              variant="progressive"
              size="medium"
              onClick={onClose}
              testId={`${testId}:close`}
            >
              {t("common:close")}
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

UpdateEquationsModal.propTypes = {
  testId: PropTypes.string,
  isAborted: PropTypes.bool,
  isSuccess: PropTypes.bool,
  onClose: PropTypes.func,
};

UpdateEquationsModal.defaultProps = {
  testId: "",
  isAborted: false,
  isSuccess: false,
  onClose: () => {},
};

const ComposedUpdateEquationsModal = compose(
  I18nHOC({ resource: ["common", "equationEditor"] })
)(UpdateEquationsModal);

export default ComposedUpdateEquationsModal;
